<template>
    <b-modal
        :id="'update-portfolio-category-modal-' + category.id"
        :ref="'update-portfolio-category-modal-' + category.id"
        :title="$t('portfolio.edit_category')"
        :size="size"
        :ok-disabled="!name"
        :ok-title="$t('common.save')"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        @ok="onOk()"
        @show="onShow()"
        modal-class="apprentice-default-modal">
        <div v-if="portfolioIn.worldmap">
            <design-2021-worldmap-component
                @continent-tabbed="setContinent($event)"
                :use-in="'continent-picker'"
                :continents-in="continents"
                ref="worldmap-component"></design-2021-worldmap-component>
            <br />
            <b-form-group
                class="faq-label-color-picker-group"
                label-for="faq-label-color-input">
                <template v-slot:label>{{ $t('common.colour') }}:</template>
                <design-2021-colorpicker
                    class="apprentice-color-picker"
                    id="profile-category-color-input"
                    :color="color"
                    @input="changeColor">
                </design-2021-colorpicker>
            </b-form-group>
            <br />
        </div>

        <!-- name -->
        <div class="category-name">
            <b-form-group
                :label="$t('portfolio.category_name')"
                label-for="category-name-input">
                <b-form-input
                    id="category-name-input"
                    v-model="name"
                    :placeholder="$t('portfolio.type_category_name_here')"></b-form-input>
            </b-form-group>
        </div>
    </b-modal>
</template>

<script>
import Design2021WorldmapComponent from '../../../worldmap/design-2021-worldmap-component.vue';
import { worldmapData } from '../../../../helpers/worldmapData';

const defaultSelectionColor = '#07A1FF';

export default {
    name: 'design-2021-portfolio-edit-update-category-modal-component',
    components: { Design2021WorldmapComponent },
    props: ['category', 'groupId', 'portfolioIn'],
    data() {
        return {
            portfolio: this.portfolioIn,
            category_id: this.category ? this.category.id : '',
            name: this.category ? this.category.name : '',
            size: this.portfolioIn.worldmap ? 'xl' : 'md',
            continent: this.category ? this.category.continent : null,
            color: this.category ? this.category.color : null,
        };
    },
    computed: {
        continents() {
            let continents = {};

            Object.keys(worldmapData.continents).forEach((continentKey) => {
                continents[continentKey] = {
                    continent: continentKey,
                    continentName: worldmapData.continents[continentKey].continent,
                    state: 'none',
                };
            });

            this.portfolioIn.categories.map((cat) => {
                if (cat.continent) {
                    continents[cat.continent].color = cat.color;
                    continents[cat.continent].categoryName = cat.name;
                    continents[cat.continent].state =
                        cat.id === this.category?.id ? 'selected' : cat.id !== null ? 'blocked' : 'none';
                }
            });

            return continents;
        },
    },
    methods: {
        onShow() {
            this.name = this.category?.name;
            this.continent = this.category?.continent;
            this.color = this.category.color ?? defaultSelectionColor;
            this.hasError = false;
        },
        onOk() {
            const categoryUpdated = {
                name: this.name,
                id: this.category_id,
                continent: this.continent,
                color: this.color,
                group_id: this.groupId,
            };
            this.categoryUpdate(categoryUpdated);
            this.$bvModal.hide('update-portfolio-category-modal');
        },
        revertChanges() {
            if (this.$refs['worldmap-component']) {
                this.$refs['worldmap-component'].changeSelectedContinent(
                    this.category?.continent,
                    this.category?.color,
                    this.name,
                ); // revert map selection
            }
        },
        setContinent(continent) {
            if (this.$refs['worldmap-component']) {
                this.continent = continent !== this.continent ? continent : null;
                this.$refs['worldmap-component'].changeSelectedContinent(
                    this.continent,
                    this.color,
                    this.continent != null ? this.name : null,
                );
            }
        },

        categoryUpdate(data) {
            this.alert.saving(
                this.$t('portfolio.edit_category'),
                this.$t('portfolio.category_will_be_changed_please_wait_a_moment'),
            );

            this.axios.post(this.routes.newPortfolioCategoryUpdate(this.portfolioIn.id, data.id), data).then(
                (response) => {
                    this.portfolio.categories = this.portfolio.categories.map((category) =>
                        category.id !== response.data.id ? category : response.data,
                    );

                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        changeColor(color) {
            this.color = color;
            if (this.continent) {
                this.$refs['worldmap-component'].changeSelectedContinent(this.continent, this.color);
            }
        },
    },
    mounted() {
        this.$root.$on('bv::modal::hide', (bvEvent, modalID) => {
            if (bvEvent.trigger !== 'ok' && modalID === 'update-portfolio-category-modal-' + this.category?.id) {
                this.revertChanges();
            }
        });
    },
    watch: {
        category: function (value) {
            this.category_id = value.id;
            this.name = value.name;
            this.color = value.color;
            this.continent = value.continent;
        },
    },
};
</script>

<style scoped></style>
